// extracted by mini-css-extract-plugin
module.exports = {"small":"576px","medium":"768px","large":"992px","xLarge":"1200px","huge":"1400px","header":"Header_header__1v0yI","title":"Header_title__3SEjb"};